document.addEventListener('DOMContentLoaded', function () {
  const salesBar = document.querySelector('.sales-bar');
  const header = document.querySelector('.shopify-section--header');
  if (!salesBar || !header) return;

  let lastScrollTop = 0;
  const scrollThreshold = 4; // minimum scroll distance to trigger hide/show

  function handleScroll() {
    const currentScroll = window.pageYOffset || document.documentElement.scrollTop;

    // Determine scroll direction
    if (Math.abs(currentScroll - lastScrollTop) <= scrollThreshold) return;

    if (currentScroll > lastScrollTop && currentScroll > salesBar.offsetHeight) {
      // Scrolling down & past the sales bar
      salesBar.style.transform = 'translateY(-100%)';
      // header.style.transform = 'translateY(-100%)';
    } else {
      // Scrolling up
      salesBar.style.transform = 'none';
      // header.style.transform = 'none';
    }

    lastScrollTop = currentScroll <= 0 ? 0 : currentScroll;
  }

  // Debounce scroll handler for better performance
  let scrollTimeout;
  window.addEventListener('scroll', function () {
    if (scrollTimeout) {
      window.cancelAnimationFrame(scrollTimeout);
    }
    scrollTimeout = window.requestAnimationFrame(function () {
      handleScroll();
    });
  });
});